class ProductBreadcrumbs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.init();
  }

  init(){
    // grab our previous page and product collections.
    this.previousPage = document.referrer;
    this.collections = this.dataset.collections.split(',');  

    this.setHTML();

    // show the breadcrumb element in snippets file
    //this.style.opacity = 1; 

    document.querySelector(".product__breadcrumbs-mobile").innerHTML = document.querySelector(".product__breadcrumbs-desktop").innerHTML;
  }

  setHTML(){
    if(window.location.href.indexOf('/collections/') >= 0) // Current Page is PLP
    {
      let collection_url = window.location.href.replace('https://fleurdumal.com','');
      if(document.querySelector(`.header__inline-menu li a[href="${collection_url}"]:not(.mega-link__image-link)`)) {
        this.innerHTML = this.buildNavigationBreadcrumbs(document.querySelector(`.header__inline-menu li a[href="${collection_url}"]:not(.mega-link__image-link)`));
      }
    }
    else // Current Page is PDP
    {
      if(this.previousPage.indexOf('/collections/') >= 0 || this.previousPage.indexOf('/pages/') >= 0) {
        // if we just came from a collection or page, set up the breadcrumbs relative to that source if it's in the navigation..
        this.innerHTML = this.setPreviousPageBreadcrumbs();
      } else {
        // otherwise, we just landed on this page from some other source, build out breadcrumbs based on the site navigation and collections the product is in.
        let flag = true;
        this.collections.forEach((collection) => {
          if(document.querySelector(`.header__inline-menu li a[href="${collection}"]:not(.mega-link__image-link)`) && flag) {
            this.innerHTML = this.buildNavigationBreadcrumbs(document.querySelector(`.header__inline-menu li a[href="${collection}"]:not(.mega-link__image-link)`));
            flag = false;
          }
        })
      }
    }
  }

  setPreviousPageBreadcrumbs() {
    let previousPageURL = this.previousPage.split('?')[0].replace(location.origin, '');
    let navItem = document.querySelector(`.header__inline-menu li a[href="${previousPageURL}"]:not(.mega-link__image-link)`);

    return this.buildNavigationBreadcrumbs(navItem);
  }

  buildNavigationBreadcrumbs (navItem){
    let breadcrumbsHTML = ``;
    // check level in the navigation
    if(navItem.classList.contains('mega-menu__link--level-3')) {
      let level1Item = navItem.closest("details").querySelector('.mega-menu__link--level-1');
      breadcrumbsHTML += `<a href="${level1Item.getAttribute('href') ? level1Item.getAttribute('href') : '&bull;'}">${level1Item.innerHTML.trim().toLowerCase()}</a><span>&nbsp; &bull; &nbsp;</span>`;
      let level2Item = navItem.parentNode.parentNode.parentNode.querySelector('.mega-menu__link--level-2');
      if( level2Item.innerHTML.trim().toLowerCase() != level1Item.innerHTML.trim().toLowerCase() ){
        breadcrumbsHTML += `<a href="${level2Item.getAttribute('href') ? level2Item.getAttribute('href') : '&bull;'}">${level2Item.innerHTML.trim().toLowerCase()}</a><span>&nbsp; &bull; &nbsp;</span>`;
      }
    } else if(navItem.classList.contains('menu-item--level-2')){
      // not encountered
    }

    breadcrumbsHTML += `<a href="${navItem.getAttribute('href') ? navItem.getAttribute('href') : '/'}">${navItem.innerHTML.trim().toLowerCase()}</a>`;

    // set this to session storage so we can regenerate this from storage rather than a re-calculation.
    // sessionStorage.setItem(location.pathname, breadcrumbsHTML)
    return breadcrumbsHTML;
  }
}

customElements.define('product-breadcrumbs', ProductBreadcrumbs)
